module.exports = __webpack_public_path__ + "static/img/bolan_b.dbb254ea.png";